import { Component, OnInit } from '@angular/core';
import { SharedService } from '../shared/shared.service';
import { Router, ActivatedRoute,  Event, NavigationStart, NavigationEnd, NavigationError } from '@angular/router';
import { from } from 'rxjs';
import { AuthServiceService } from '../auth-service.service';
import { configurton } from '../../../../l2-radiology/src/assets/data/configuration';
//import { OmsServiceService } from '../services/oms-service.service';
import { OmsServiceService } from '../../../../l2-radiology/src/app/services/oms-service.service';
import { LogoutConfirmModalComponent } from '../../../../l2-radiology/src/app/modal-popups/logout-confirm-modal/logout-confirm-modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Location } from '@angular/common';


@Component({
  selector: 'lib-common-header',
  templateUrl: './common-header.component.html',
  styleUrls: ['./common-header.component.scss']
})
export class CommonHeaderComponent implements OnInit {
  from: string = "";
  userDataList = [];
  logInUserResponse = {};
  associateName: string = "";
  branchName: string = "";
  sessionId: string = "";
  role: string = "";
  configuraionData;
  headerData: [];

  //show header tab
  isPendingPrescription: boolean = false;
  isUnconfirmedOrder: boolean = false;
  isRejectedOrders: boolean = false;
  isCancelledOrders: boolean = false;
  isUploadReport: boolean = false;
  isCompletedOrders: boolean = false;
  isTestingPendingOrders: boolean = false;
  isExecuteByVendor: Boolean = false;
  isSlotConfirmed: Boolean = false;
  isPaymentConfirmed: Boolean = false;
  isReimbursement: boolean = false;

  loggedInUserName: string = "";
  loginUserInfoList = [

  ];
  userConfirmedList = [];
  //for button highlate 
  isPendingPrescriptionBtn: boolean = false;
  isUnconfirmedOrderBtn: boolean = false;
  isRejectedOrdersBtn: boolean = false;
  isCancelledOrdersBtn: boolean = false;
  isUploadReportBtn: boolean = false;
  isCompletedOrdersBtn: boolean = false;
  isAllOrdersBtn: boolean = false;
  isTestingPendingBtn: boolean = false;
  isExecuteByVendorBtn: Boolean = false;
  isSlotConfirmedBtn: Boolean = false;
  isPaymentConfirmedBtn: Boolean = false;
  isUnconfirmed: Boolean = false;
  isUnconfirmedRequired: Boolean = false;
  isCustomerChecked: Boolean = false;
  isReimbursementBtn: boolean = false;
  isEscalationBtn: boolean = false;
  isEscalation: boolean = false;
  isRefundBtn: boolean = false;
  isLeads:boolean=false;
  roleValue:any;
  isRecovery:boolean=false;

  constructor(public sharedService: SharedService,
    private _router: Router,
    private activatedRoute: ActivatedRoute,
    private authServiceService: AuthServiceService,
    private omsServiceService: OmsServiceService,
    private modalService: NgbModal,
    private location :Location,
  ) {

    let currentRoute
    this._router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        currentRoute = event.url;
        // const pathName = currentRoute.substring(0, currentRoute.indexOf('?'));
        const pathName = currentRoute;
        console.log(`pathName`, pathName);
        if (pathName == "/reimbursements") {
          this.isReimbursementBtn = true
          this.isUnconfirmedOrderBtn = false
          this.isEscalationBtn = false
          this.isLeads=false
        }
       else if(pathName == "/orders"){
          this.isUnconfirmedOrderBtn = true
          this.isReimbursementBtn = false
          this.isEscalationBtn = false
          this.isLeads=false
        } 
      else if(pathName == "/escalations/refund"){
          this.isUnconfirmedOrderBtn = false
          this.isReimbursementBtn = false
          this.isEscalationBtn = false
          this.isRefundBtn = true
          this.isLeads=false
        }else if(pathName == "/leads"){
          this.isUnconfirmedOrderBtn = false
          this.isReimbursementBtn = false
          this.isEscalationBtn = false
          this.isRefundBtn = false
          this.isLeads=true
        }else if(pathName.includes('/ordersList/')){
          this.isUnconfirmedOrderBtn = false
          this.isReimbursementBtn = false
          this.isEscalationBtn = false
          this.isRefundBtn = false
          this.isLeads=false
        }
        else  {
          this.isReimbursementBtn = false
          this.isUnconfirmedOrderBtn = false
          this.isEscalationBtn = true
          this.isLeads=false
        }
      }
      if (event instanceof NavigationError) {
        console.log(event.error);
      }
    });
  }

  ngOnInit(): void {
    this.isCustomerChecked =false;
    this.isUnconfirmedRequired = false;
    this.userDataList = [];
    this.isAllOrdersBtn = false;
    // this.isUnconfirmedOrderBtn=true
    // this.loggedInUserName = window.localStorage.getItem('actionByName');
    console.log(this.loggedInUserName);
    console.log(this.configuraionData);
    this.sharedService.requestFrom.subscribe(from => {

      //this.from = from;
      //console.log("from in header component"+this.from);

    });

    this.sharedService.hideHeaderData.subscribe((value:any)=>{
     
      console.log(`value`, value);
    })

    this.userConfirmedList = [{ name: "All", value: 2625505 }, { name: "Slot Not Confirmed", value: 26 },{ name: "Slot Not Confirmed", value: 25 }, { name: "Payment NoT Confirmed", value: 505 }]

    this.sharedService.role.subscribe(role => {
      if(localStorage.getItem('userDataRoleBased') != undefined && JSON.parse(localStorage.getItem('userDataRoleBased')).tenant != undefined && JSON.parse(localStorage.getItem('userDataRoleBased')).tenant =='1000267'){
        this.isRecovery=true;
      }

      this.role = role;

      console.log("role=" + this.role);
      if ((role != undefined && role != "") || this.role == "0") {
        //this.sharedService.role.next(role);
        this.configuraionData = configurton;
        this.configuraionData = this.configuraionData.filter(x => x.role == role);
        this.loggedInUserName = window.localStorage.getItem('actionByName');
        // this.loginUserInfoList.push({ "id": "", name: this.loggedInUserName });

        if ((localStorage.getItem('userDataRoleBased') !== null && localStorage.getItem('userDataRoleBased') !== '')) {
           this.roleValue =JSON.parse(localStorage.getItem('userDataRoleBased'))
          this.loginUserInfoList.push({ "id": "", name: `${this.roleValue.role}` });
        }
        this.loginUserInfoList.push({ "id": "logout", name: "Logout" });
        var headerData = this.configuraionData[0]["header_tab"];

        if(this.role == "superadmin"){
          this.isCustomerChecked =true;
          
        }

        if (headerData.indexOf("Pending Prescription") !== -1) {

          this.isPendingPrescription = true;
        }

        if (headerData.indexOf("Un-confirmed Order") !== -1) {

          this.isUnconfirmedOrder = true;
        }
        if (headerData.indexOf("Upload Report") !== -1) {

          this.isUploadReport = true;
        }
        // if (headerData.indexOf("Upload Report") !== -1) {

        //   this.isUploadReport = true;
        // }
        if (headerData.indexOf("Completed Orders") !== -1) {

          this.isCompletedOrders = true;
        }
        if (headerData.indexOf("Rejected Orders") !== -1) {

          this.isRejectedOrders = true;
        }
        if (headerData.indexOf("Cancelled Orders") !== -1) {

          this.isCancelledOrders = true;
        }
        if (headerData.indexOf("Tests Pending") !== -1) {

          this.isTestingPendingOrders = true;
        }
        if (headerData.indexOf("Slot Not Confirmed") !== -1) {

          this.isSlotConfirmed = true;
        }
        if (headerData.indexOf("Execute By Vendor") !== -1) {

          this.isExecuteByVendor = true;
        }
        if (headerData.indexOf("Payment Not confirmed") !== -1) {

          this.isPaymentConfirmed = true;
        }
        if (headerData.indexOf("Reimbursement") !== -1) {

          this.isReimbursement = true;
        }
        if (headerData.indexOf("Escalation") !== -1) {
 
          this.isEscalation = true;
        }
      }
    });

    this.activatedRoute.queryParamMap.subscribe(params => {

      this.sessionId = params.get('session');
      if (this.sessionId != undefined) {
        this.sharedService.sessionId.next(this.sessionId);
      }

      this.sharedService.requestFrom.subscribe(from => {

        this.from = from;

      });

      if (this.sessionId != undefined) {
        // this.getUserInfo(this.sessionId);
      }


    });

//  let currentRoute
//     this._router.events.subscribe((event: Event) => {
//       if (event instanceof NavigationEnd) {
//         currentRoute = event.url;
//         const pathName = currentRoute.substring(0, currentRoute.indexOf('?'));
//         console.log(`pathName`, pathName);
//         if (pathName == "/reimbursements") {
//           this.isReimbursementBtn = true
//           this.isUnconfirmedOrderBtn = false
//         } else {
//           this.isUnconfirmedOrderBtn = true
//           this.isReimbursementBtn = false
//         }
//       }
//       if (event instanceof NavigationError) {
//         console.log(event.error);
//       }
//     });


  }

   search(val) {
    this.sharedService.headerData.next(val);
    this.sharedService.headerSelectedStatus.next(val);
    this.highlateBtns(val);
    if (val == 'reimbursement') {
      this.reimbursementPage();
    } else if (val == 'escalation') {
      this.escalationPage()
    } else if (val == 'refund') {
      this.refundPage()
    } else if (val == 'lead') {
      this._router.navigate(['/leads']);
    }else {
      this.homePage();
    }
  }

  searchByStatus(val) {
    this.sharedService.headerData.next(val);
    this.sharedService.headerSelectedStatus.next(val);
    this.highlateBtns(val);
    this.homePage();

  }

  getUserInfo(sessionId) {
    this.logInUserResponse = {};
    let userInfoRequest = {};
    this.userDataList = [];
    userInfoRequest["token"] = sessionId;
    userInfoRequest["action"] = 'OMS/api/auth.php/v1/gettokendata';
    userInfoRequest["type"] = 'post';
    this.submitTokenValidate(userInfoRequest);

  }
  homePage() {


    this.sharedService.sessionId.subscribe(val => {

      this.sessionId = val;
    });
    this.sharedService.requestFrom.subscribe(val => {

      this.from = val;
    });

    // this._router.navigate(['/orders'], { queryParams: { from: this.from, session: this.sessionId } });
    this._router.navigate(['/orders']);
  }

  reimbursementPage() {
    this.sharedService.sessionId.subscribe(val => {
      this.sessionId = val;
    });
    this.sharedService.requestFrom.subscribe(val => {
      this.from = val;
    });
    this._router.navigate(['/reimbursements']);
  }

   escalationPage() {
    this.sharedService.sessionId.subscribe(val => {
      this.sessionId = val;
    });
    this.sharedService.requestFrom.subscribe(val => {
      this.from = val;
    });
    this._router.navigate(['/escalations']);
  }

  refundPage() {
    this.sharedService.sessionId.subscribe(val => {
      this.sessionId = val;
    });
    this.sharedService.requestFrom.subscribe(val => {
      this.from = val;
    });
    this._router.navigate(['/escalations/refund']);
  }

  submitTokenValidate(userInfoRequest) {
    this.authServiceService.getUserInfo(userInfoRequest).subscribe(
      (res) => {


        this.logInUserResponse = res;

        let associateName = this.logInUserResponse["associate_name"];
        let branchName = this.logInUserResponse["branch_name"];
        if (associateName != undefined) {
          this.userDataList.push(associateName);
        }
        if (branchName != undefined) {
          this.userDataList.push(branchName);
        }


        this.updateActionData(this.logInUserResponse)

      });
  }

  updateActionData(data) {

    let actionById = "";
    let actionByName = "";
    let from = "";
    let role = "";

    this.sharedService.requestFrom.subscribe(val => {

      from = val;
    });
    if (from == "ard") {
      actionById = data.officer_id;
      actionByName = data.officer_name;
      role = data.rolea;
    } else {
      actionById = data.associate_id + "-" + data.branch_id;
      actionByName = data.associate_name + "-" + data.branch_name;
      role = data.rolea;
    }
    if (actionById != undefined) {
      localStorage.setItem("actionById", actionById);

    }
    if (actionByName != undefined) {
      localStorage.setItem("actionByName", actionByName);
    }
    if (role != undefined) {
      localStorage.setItem("role", role);
    }
  }

  logout(value) {
    console.log("logout");
    if (value == "Logout") {

      this.openLogoutConfirmModal();

    }


  }

  openLogoutConfirmModal() {
    console.log("prescription upload called");

    const modalRef = this.modalService.open(LogoutConfirmModalComponent);

    const closeModelRef = modalRef.result.then(
      (res) => {
        this.loginUserInfoList = [];
        //document.getElementById('timeDropDown').innerHTML="ram";
        this.loginUserInfoList.push({ "id": "", name: this.loggedInUserName });
        this.loginUserInfoList.push({ "id": "logout", name: "Logout" });
      }

    );



  }

  highlateBtns(val) {

    this.isPendingPrescriptionBtn = false;
    this.isAllOrdersBtn = false;
    this.isCompletedOrdersBtn = false;
    this.isRejectedOrdersBtn = false;
    this.isCancelledOrdersBtn = false;
    this.isUnconfirmedOrderBtn = false;
    this.isTestingPendingBtn = false;
    this.isExecuteByVendorBtn = false;
    this.isSlotConfirmedBtn = false;
    this.isPaymentConfirmedBtn = false;
    this.isReimbursementBtn = false;
    this.isEscalationBtn = false;
    this.isRefundBtn = false;
    this.isLeads=false;

    if (val == "1001") {
      this.isPendingPrescriptionBtn = true;

    } else if (val == "26") {
      this.isUnconfirmedOrderBtn = true;

    }
    else if (val == "6") {
      this.isCompletedOrdersBtn = true;

    }
    else if (val == "9") {
      this.isRejectedOrdersBtn = true;

    }else if(val=="8"){
      this.isCancelledOrdersBtn = true;
    }
    else if (val == "2") {

      this.isTestingPendingBtn = true;

    }
    else if (val == "301") {

      this.isExecuteByVendorBtn = true;

    }
    
    else if (val == "25") { //opd_c 26
      this.isUnconfirmedOrderBtn = true;

    }

    else if (val == "reimbursement") {
      this.isReimbursementBtn = true;

    } else if (val == "escalation") {
      this.isEscalationBtn = true;
 
    } else if (val == "refund") {
      this.isRefundBtn = true;
 
    }else if (val == "lead") {
      this.isLeads = true;
    }

    else {


      this.isAllOrdersBtn = true;

    }


  }
}
